// reports/TenantList.jsx

import { useState } from "react";
import { useQuery } from "@tanstack/react-query";

import { Button, Select, Dropdown } from "antd";
import { Menu, Form, Space, DatePicker } from 'antd';

import { IconButton } from "@mui/material";
import TuneIcon from "@mui/icons-material/Tune";

// Font Awesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileExcel} from '@fortawesome/free-solid-svg-icons';

import dayjs from "dayjs";

import authAxios from "../components/authAxios";
import DashboardHeader from "../components/DashboardHeader";
import Loading from "../components/Loading";
import StandardReportTable from "./StandardReportTable";
import './Report.css';


const formatAmount = (value) => {
    if (value == null) return "—";
    return Number(value).toLocaleString("en-KE", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
};

const formatDate = (value) =>
    value ? dayjs(value).format("DD-MM-YYYY") : "—";

const UpcomingLeaseRenewals = () => {
    const { RangePicker } = DatePicker;
    const [propertyId, setPropertyId] = useState(null);


    // Fetch properties for the filter dropdown
    const { data: properties = [] } = useQuery({
        queryKey: ["properties-list"],
        queryFn: async () => {
            const res = await authAxios.get("rentals/properties/");
            return res.data;
        },
    });

    const { data, isLoading } = useQuery({
        queryKey: ["tenant-list", propertyId],
        queryFn: async () => {
            const params = new URLSearchParams();
            if (propertyId) params.set("property_id", propertyId);
            const res = await authAxios.get(`/rentals/upcoming-lease-renewals/?${params}`);
            return res.data;
        },
    });

    const menu = (
        <Menu>
            <form className="filter-form">
                <Space direction="vertical">
                    <RangePicker 
                        style={{margin:'10px'}}  
                        // onChange={onChange} 
                        placement="bottomRight" 
                    /> 
                </Space>
            </form>
        </Menu>
    );

    if (isLoading) return <Loading loading />;

    // const { rows = [], total_tenants } = data ?? {};

    return (
        <div className="dashboard-main standard-report">
            <section className="dashboard-content">
                <div className="dashboard-content-header-nav">
                    <DashboardHeader
                        dashboardTitle="Upcoming Lease Renewals"
                        dashboardPreTitle="Reports"
                    />

                    <div className="dashboard-content-header-nav-icons">
                        {/* <IconButton onClick={downloadXLS}> */}
                        <IconButton disabled>
                            <FontAwesomeIcon className="menu-icon" icon={faFileExcel} />
                        </IconButton>
                        <Dropdown disabled overlay={menu} trigger={['click']} placement="bottomRight" arrow>
                            <Button className="menu-button-filter" variant="outlined" startIcon={<TuneIcon />}>
                                Filter
                            </Button>
                        </Dropdown>
                    </div>
                </div>

                <StandardReportTable
                    columns={data?.columns || []}
                    rows={data?.rows || []}
                    totals={data?.totals || {}}
                />
            </section>
        </div>
    );
};

export default UpcomingLeaseRenewals;